import branded from "../../assests/images/branded.jpg";
const caseStudies = [
  branded,
  branded,
  branded,
  branded,
  branded,
  branded

];

export default function CaseStudiesSection() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-20">
      <h2 className="text-center text-3xl md:text-4xl font-extrabold mb-14">
        CHECK OUT <span className="text-[#92abc4] italic">our</span> CASE STUDIES
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {caseStudies.map((img, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-lg shadow-md group"
          >
            <img
              src={img}
              alt={`Case Study ${index + 1}`}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
